import { Injectable } from "@angular/core";
import { Platform } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { DiskService } from '../disk/disk.service';
import { GlobalErrorHandler } from '../error-handler/error-handler-service';
import { UIService } from "../ui/ui.service";

export enum GPS_STATUS {
  VALID = 600000000,
  INVALID = 600000001
}

export type LocationSettingTriggerPoint =
  | 'home'
  | 'authService'
  | 'accountList'
  | 'account-meeting-distance'
  | 'contact-spotlight'
  | 'contact-meeting-distance'
  | null;

export interface Coordinates {
  latitude: number;
  longitude: number;
}

export interface LocationNameResult extends Coordinates {
  name: string;
}

@Injectable({
  providedIn: 'root'
})
export class LocationOfflineService {
  public locations: string[] = [];

  constructor(
    private disk: DiskService,
    public globalErrorHandler: GlobalErrorHandler,
    public translate: TranslateService,
    public uiService: UIService,
    private platform: Platform,
  ) {
    this.init();
  }

  async init(): Promise<void> {
    await this.platform.ready();
  }

  /**
   * Maps and saves our location to in memory and disk
   */
  public mapLocations(response: unknown): void {
    if (response && Array.isArray(response)) {
      this.locations = [...response];
      this.disk.updateOrInsert('locations', () => ({ raw: response }))
        .catch(error => this.globalErrorHandler.handleError(new Error(error)));
    }
  }

  public get getLocationData(): string[] {
    return this.locations;
  }
}